import Customization from "./customization";
import { StoreCategory, css } from "./customization/category";
import BaseCustomization from "./customization/base";
import CustomizationRequest from "./customization/request";

// Connects to data-controller="site-builder--color-palette"
export default class extends BaseCustomization {
  static targets = ["selection", "reset"];
  static outlets = ["site-builder--color-picker"];

  get colorPickers() {
    return this.siteBuilderColorPickerOutlets;
  }

  initialize() {
    this.tabItem = document.getElementById("for-colors");
  }

  initializeSelection() {
    const defaultValue = this.values();

    const areAllColorsSelected = this.colorPickers.every((color) => {
      return defaultValue[color.inputTarget.dataset.colorId];
    });

    if (
      defaultValue["primary-background-color"] ||
      defaultValue["accent-color"]
    ) {
      this.highlightTabSelection();
    }

    if (areAllColorsSelected) {
      /*
          Constitutes as palette selection
       */
      this.#selectByValue(defaultValue);
    }
  }

  apply(e) {
    let payload = {};

    for (const color of e.currentTarget.firstChild.children) {
      const type = color.dataset.colorId;
      payload = { ...payload, [type]: color.style.backgroundColor };
    }
    Customization.localUpdate(payload, StoreCategory.CSS);
    this.#updateSelectedPalette(e.currentTarget);
    this.#updateColorPickers(payload);
    this.highlightTabSelection();
    this.showReset();
  }

  #updateSelectedPalette(current) {
    this.removeSelectedOption();
    current.classList.add("selected");
  }

  #updateColorPickers(payload) {
    this.colorPickers.forEach((colorPicker) => {
      const color = payload[colorPicker.inputTarget.dataset.colorId];
      colorPicker.picker.setColor(color);
      colorPicker.picker.setColorRepresentation("HEXA");
    });
  }

  reset() {
    const cssUpdates = {};

    this.colorPickers.forEach((colorPicker) => {
      const color = colorPicker.inputTarget.dataset.colorId;
      cssUpdates[color] = null;
    });

    Customization.localUpdate(cssUpdates, StoreCategory.CSS);
    this.removeSelectedOption();
    this.removeTabSelection();
    this.hideReset();
  }

  #selectByValue(payload) {
    const current = this.selectionTargets.find((selection) => {
      for (const color of selection.firstChild.children) {
        const type = color.dataset.colorId;

        /*
            Browsers return rgb values when asked via element.styles.background-color
            Using this to avoid computation to convert from rgb to hex.
         */
        const value = color
          .getAttribute("style")
          .match("background-color: (#.*);")[1];

        if (
          value.localeCompare(payload[type], "us", {
            sensitivity: "accent",
          }) !== 0
        ) {
          return false;
        }
      }
      return true;
    });

    if (current) {
      current.classList.add("selected");
    } else {
      this.removeSelectedOption();
    }
  }

  fetchFromStore() {
    return css.colors;
  }

  fetchFromPreview() {
    return {
      "primary-background-color": CustomizationRequest.getCssVariable(
        "primary-background-color"
      ),
      "accent-color": CustomizationRequest.getCssVariable("accent-color"),
    };
  }
}
